var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.link.data.redirect_enabled)?_c('a',{staticClass:"btn",class:[
        'btn-' + _vm.background,
        'btn-' + _vm.size
    ],attrs:{"href":_vm.$helpers.getRedirectUrl(_vm.link, _vm.placement, _vm.position),"target":"_blank"},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v("\n    "+_vm._s(_vm.text)+"\n    "),(_vm.icon)?_c('i',{class:_vm.icon}):_vm._e()]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }